(function () {
  const ChatForm = () => {
    const showWaitingMessage = () => {
      const waitingMessage = document.getElementById('waiting-message');
      waitingMessage?.classList.replace('hidden', 'flex');
    }

    const showSelectedValueMessage = () => {
      const toast = document.getElementById('toast-success');

      toast.classList.replace('hidden', 'flex');
      toast.style.opacity = '1';

      setTimeout(() => {
        toast.style.opacity = '0';

        setTimeout(() => {
          toast.classList.replace('flex', 'hidden');
        }, 300);
      }, 700);
    }

    return {
      insertSelectedValue(el) {
        const value = el.value;

        if (!value) return;

        const input = document.getElementById('text');
        const currentText = input.value;

        input.value = currentText ? `${currentText} ${value} ` : `${value} `;

        el.slim.setSelected('');

        showSelectedValueMessage();
      },

      handleEnter(event) {
        if (event.shiftKey) return;

        event.preventDefault();

        this.submitMessage();
      },

      submitMessage() {
        const input = this.$refs.input;
        if (!input.value.trim()) return;

        document.getElementById('form-message').requestSubmit();

        input.value = '';

        showWaitingMessage();

        this.$nextTick(() => {
          const list = document.getElementById('message-list');
          if (list) list.scrollTop = list.scrollHeight;
        })
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.ChatForm = ChatForm;
  };

  return ChatForm;
})();
